import { render, staticRenderFns } from "./DocumentTreeNode.vue?vue&type=template&id=1846bf7b&scoped=true"
import script from "./DocumentTreeNode.vue?vue&type=script&lang=js"
export * from "./DocumentTreeNode.vue?vue&type=script&lang=js"
import style0 from "./DocumentTreeNode.vue?vue&type=style&index=0&id=1846bf7b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1846bf7b",
  null
  
)

export default component.exports